import React from 'react'
import FinFactorContainer from 'containers/FinFactor/FinFactorContainer'

const FinfactorBankAccountPage = () => {
    return (
        <FinFactorContainer />
    )
}

export default FinfactorBankAccountPage